export default __webpack_public_path__ + "static/telehealth-solutions-rural-healthcare-6ecfc30b7a755ab581007135796bd2ad.jpg";